import styled from 'styled-components';
export const StyledSearchWrapper = styled.div.withConfig({
  displayName: "StyledSearchWrapper",
  componentId: "yin1q2-0"
})(["--search-icon-fill:", ";position:absolute;top:0;left:0;z-index:1311;width:", ";background:", ";border-radius:8px;transition:width 0.1s ease-in,box-shadow 0.1s ease-in,max-height 0.1s ", ",background 0.1s ease-in !important;overflow:hidden;max-height:", ";transform:translateZ(0);will-change:width,box-shadow,max-height,background;box-shadow:", ";"], ({
  isOpen,
  theme
}) => isOpen ? theme.color['icon-core-subtle'] : theme.color['border-core-subtle'], ({
  isOpen
}) => isOpen ? 'min(800px, calc(100vw - var(--global-nav-vertical-nav-width) - var(--copilot-sidebar-width, 0px)) - 10px)' : '100%', ({
  isOpen,
  theme
}) => isOpen ? theme.color['fill-surface-default'] : theme.color['fill-accent-neutral-subtle'], ({
  isOpen
}) => isOpen ? 'cubic-bezier(1.000, 0.010, 0.875, 1.000)' : 'cubic-bezier(0.055, 0.000, 0.195, 1.000)', ({
  isOpen
}) => isOpen ? '1000px' : '32px', ({
  isOpen
}) => isOpen ? '0 0 30px 13px rgb(0 0 0 / 20%)' : 'rgba(0, 0, 0, 0) 0px 0px 0px 0px');